import { render, staticRenderFns } from "./TabsManager.vue?vue&type=template&id=96cf3bc0&scoped=true&"
import script from "./TabsManager.vue?vue&type=script&lang=js&"
export * from "./TabsManager.vue?vue&type=script&lang=js&"
import style0 from "./TabsManager.vue?vue&type=style&index=0&id=96cf3bc0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cf3bc0",
  null
  
)

export default component.exports